import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, MOBILE_SIDECAR_CREATIVE_AD_FIELDS } from "./definitions";
import BaseCreativeControls from "./BaseCreativeControls";
import ColorPicker from "./ColorPicker";
const CREATIVE_TYPE = CREATIVE_NAMES.MOBILE_SIDECAR_CREATIVE;

export default function MobileSidecarCreative({
    collapsedBanner,
    expandedBanner,
    handleChange,
    impressionTag,
    currentCustomer,
    adServingType,
    clickTag,
    ctaBgColor = '#ccc',
    ctaTextColor = '#000'
}) {

    return (
        <>
            <BaseCreativeControls
                isClickTagRequired={true}
                adServingType={adServingType}
                changeHandler={handleChange}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
                renderClickUrlInput={true}
                clickTag={clickTag}
            >

                <AssetInputOrUploadSection
                    inputValue={collapsedBanner}
                    inputLabel="Small banner (300x250px)"
                    inputName={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.collapsedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <AssetInputOrUploadSection
                    inputValue={expandedBanner}
                    inputLabel="Expanded banner (300x600px)"
                    inputName={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.expandedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <ColorPicker
                    label="CTA background color"
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.ctaBgColor}
                    value={ctaBgColor}
                />

                <ColorPicker
                    label="CTA background color"
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.ctaTextColor}
                    value={ctaTextColor}
                />

            </BaseCreativeControls>
        </>
    );
}
